<script>
  /* Executable code section of the program */
  //Tools importation
  import AttendeeMeetingCard from "./Cards/AttendeeMeetingCard.svelte";
  //Tools importation
  import { invitedAttendeesArray } from "../apis/storage";
  //Auxiliary variables
  let filter = "";
  export let attendeesArray
  $: dinamicArray = attendeesArray



  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="containerCentral">
  
  <div class="atteendeesCardsContainer">
    {#each dinamicArray as attendee}
    {#if $invitedAttendeesArray.some(obj =>obj.id === attendee.id)}
    {#key attendee.id}
    <AttendeeMeetingCard data = {attendee} attendeId ={attendee.id} isCheckedExtern = {true}/>
    {/key}
    {:else}
    {#key attendee.id}
    <AttendeeMeetingCard data = {attendee} attendeId ={attendee.id} isCheckedExtern = {false}/>
    {/key}
    {/if}
    {/each}
  </div>
</section>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  .containerCentral {
    width: 100%;
    height: auto;
    background-color: #f4f4f4;
  }
  .atteendeesCardsContainer{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
  }

  /* End of the section */
</style>
